/**
 * Viewport / responsive state. Drives the mobile layout (bottom nav + drawer)
 * vs the desktop layout (left rail + inline sidebar). Single source of truth so
 * the layout, the bottom nav, and the drawer all react to the same breakpoint.
 *
 * `isMobile` tracks the `sm` Tailwind breakpoint (640px) — below it we switch to
 * the phone shell. `drawerOpen` is the slide-in channel sidebar, only
 * meaningful on mobile (where the sidebar is otherwise off-screen).
 */
class ViewportState {
  isMobile = $state(false);
  // Two panes stop fitting before the phone shell takes over: a list beside a
  // detail needs ~760px. Wider than `isMobile`, and it never replaces it.
  isNarrow = $state(false);
  drawerOpen = $state(false);
  #mql: MediaQueryList | null = null;
  #narrowMql: MediaQueryList | null = null;

  init(): void {
    if (typeof window === "undefined" || this.#mql) return;
    this.#mql = window.matchMedia("(max-width: 639px)");
    this.isMobile = this.#mql.matches;
    this.#mql.addEventListener("change", (e) => {
      this.isMobile = e.matches;
      // Leaving mobile (rotate / resize) must not strand an open drawer.
      if (!e.matches) this.drawerOpen = false;
    });
    this.#narrowMql = window.matchMedia("(max-width: 759px)");
    this.isNarrow = this.#narrowMql.matches;
    this.#narrowMql.addEventListener("change", (e) => {
      this.isNarrow = e.matches;
    });
  }

  openDrawer(): void {
    this.drawerOpen = true;
  }
  closeDrawer(): void {
    this.drawerOpen = false;
  }
  toggleDrawer(): void {
    this.drawerOpen = !this.drawerOpen;
  }
}

export const viewportState = new ViewportState();
